import React from 'react';
import PropTypes from 'prop-types';

import { CMS_CONFIG } from '../../../config/cms.config';

import { MInputField } from '../../molecules';

export default function OProductInfo({
	form,
	onChange,
	languageUuid,
}) {
	return (
		<section className="o-product-detail-info">
			{
				CMS_CONFIG.PRODUCT_INFO.map(item => (
					<MInputField
						id={item.id}
						key={item.id}
						label={item.label}
						value={(form[`${languageUuid}-${item.key}`] || { value: '' }).value}
						onChange={(value, error) => { onChange({ value, error, field: item.key }); }}
					/>
				))
			}
		</section>
	);
}

OProductInfo.propTypes = {
	form: PropTypes.object,
	languageUuid: PropTypes.string,
	onChange: PropTypes.func.isRequired,
};

OProductInfo.defaultProps = {
	languageUuid: '',
	form: {},
};




// WEBPACK FOOTER //
// ./src/components/organisme/cms/_organisme.product-info.js